import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function ChangePassword() {
  const { currentUser, updateUserPassword, reauthenticateUser } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  
  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    if (!currentUser) {
      setError('ログインが必要です。');
      setLoading(false);
      return;
    }

    // バリデーション
    if (!formData.currentPassword) {
      setError('現在のパスワードを入力してください。');
      setLoading(false);
      return;
    }

    if (formData.newPassword.length < 6) {
      setError('新しいパスワードは6文字以上で入力してください。');
      setLoading(false);
      return;
    }

    // パスワードの強度チェック（英字と数字の両方を含む）
    const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/;
    if (!passwordRegex.test(formData.newPassword)) {
      setError('パスワードは英字と数字を組み合わせる必要があります。');
      setLoading(false);
      return;
    }

    if (formData.newPassword !== formData.confirmPassword) {
      setError('新しいパスワードが一致しません。');
      setLoading(false);
      return;
    }

    try {
      // 現在のパスワードで再認証
      await reauthenticateUser(formData.currentPassword);
      
      // パスワードを更新
      await updateUserPassword(formData.newPassword);

      setSuccess('パスワードを変更しました。');
      
      setTimeout(() => {
        navigate('/profile');
      }, 2000);
      
    } catch (error) {
      console.error('パスワードの変更に失敗しました:', error);
      
      if (error.code === 'auth/wrong-password') {
        setError('現在のパスワードが正しくありません。');
      } else if (error.code === 'auth/weak-password') {
        setError('パスワードが弱すぎます。より強力なパスワードを設定してください。');
      } else {
        setError('パスワードの変更に失敗しました。もう一度お試しください。');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate('/profile');
  };

  return (
    <div className="change-password-container">
      <div className="card">
        <h1 className="page-title">パスワード変更</h1>
        
        {error && <div className="alert alert-danger">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}
        
        <form onSubmit={handleSubmit} className="change-form">
          <div className="form-group">
            <label className="form-label">現在のパスワード *</label>
            <input
              type="password"
              name="currentPassword"
              className="form-control"
              value={formData.currentPassword}
              onChange={handleChange}
              required
              placeholder="現在のパスワードを入力してください"
            />
          </div>

          <div className="form-group">
            <label className="form-label">新しいパスワード *</label>
            <input
              type="password"
              name="newPassword"
              className="form-control"
              value={formData.newPassword}
              onChange={handleChange}
              required
              minLength="6"
              placeholder="6文字以上の新しいパスワード"
            />
          </div>

          <div className="form-group">
            <label className="form-label">新しいパスワード（確認） *</label>
            <input
              type="password"
              name="confirmPassword"
              className="form-control"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
              minLength="6"
              placeholder="新しいパスワードを再入力"
            />
          </div>

          <div className="password-requirements">
            <h4>パスワードの要件:</h4>
            <ul>
              <li>6文字以上</li>
              <li>英字と数字の両方を含む</li>
              <li>簡単に推測されないもの</li>
            </ul>
          </div>

          <div className="notice">
            <p>⚠️ セキュリティのため、現在のパスワードでの再認証が必要です。</p>
            <p>🔒 共有PCなどで長時間ログインしている場合は、セキュリティを確保するため再ログインをお勧めします。</p>
          </div>

          <div className="form-actions">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleCancel}
              disabled={loading}
            >
              キャンセル
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? '変更中...' : '変更'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ChangePassword;
